import script from "./SolicitacaoAdiantamentoGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./SolicitacaoAdiantamentoGrid.vue?vue&type=script&setup=true&lang=js"

import "./SolicitacaoAdiantamentoGrid.vue?vue&type=style&index=0&id=bae24040&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bae24040"]])

export default __exports__